import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { connect } from 'react-redux';
import {
  fetchBillingInfo,
  clearFetchBillingInfo,
  patchBillingInfo,
  clearPatchBillingInfo,
} from 'redux/billing/actions';

import { Loader } from 'semantic-ui-react';

import CommonStanaloneInput
  from 'components/elements/inputs/CommonStanaloneInput';
import CommonMessage from 'components/common/CommonMessage';

import validate from './validate';

import './BillingDetailsForm.css';

const BillingDetailsForm = props => {
  const {
    fetchBillingInfo,
    clearFetchBillingInfo,
    patchBillingInfo,
    clearPatchBillingInfo,
    billingInfo,
    billingInfoError,
    patchBillingInfoSuccess,
    patchBillingInfoError,
  } = props;
  const { t } = useTranslation();

  useEffect(() => {
    fetchBillingInfo();
    return () => {
      clearFetchBillingInfo();
      clearPatchBillingInfo();
    };
  }, []);

  useEffect(() => {
    if (patchBillingInfoSuccess) {
      fetchBillingInfo();
    }
    clearPatchBillingInfo();
  }, [patchBillingInfoSuccess]);

  const loader = !billingInfo && !billingInfoError &&
    <Loader active inline="centered" />;
  const billingDetailsError = billingInfoError &&
    billingInfoError.error &&
    (
      <CommonMessage
        error
        content={billingInfoError.error}
      />
    );
  const billingDetails = billingInfo && (
    <div className="wrapper">
      {/* CONTACT INFORMATION */}
      <div className="section-title">{t("Contact Information")}</div>
      <div className="form-section">
        <div className="field-row">
          {/* Full Name */}
          <CommonStanaloneInput
            key="billing-details-form-input-key-full-name"
            fieldName="full_name"
            label={t("Full Name")}
            initValue={billingInfo.full_name}
            executedAction={patchBillingInfo}
            patchError={patchBillingInfoError}
          />

          {/* Email */}
          <CommonStanaloneInput
            key="billing-details-form-input-key-email"
            fieldName="email"
            label={t("Email")}
            initValue={billingInfo.email}
            executedAction={patchBillingInfo}
            patchError={patchBillingInfoError}
            validate={validate}
          />
        </div>
        <div className="field-row">
          {/* Company Name */}
          <CommonStanaloneInput
            key="billing-details-form-input-key-company-name"
            fieldName="company_name"
            label={t("Company Name (optional)")}
            initValue={billingInfo.company_name}
            executedAction={patchBillingInfo}
            patchError={patchBillingInfoError}
          />
        </div>
      </div>

      {/* BILLING ADDRESS */}
      <div className="section-title">{t("Billing Address (optional)")}</div>
      <div className="form-section">
        <div className="field-row">
          <CommonStanaloneInput
            key="billing-details-form-input-key-address-street-line1"
            fieldName="address_street_line1"
            label={t("Address Line 1")}
            initValue={billingInfo.address_street_line1}
            executedAction={patchBillingInfo}
            patchError={patchBillingInfoError}
          />
          <CommonStanaloneInput
            key="billing-details-form-input-key-address-street-line2"
            fieldName="address_street_line2"
            label={t("Address Line 2")}
            initValue={billingInfo.address_street_line2}
            executedAction={patchBillingInfo}
            patchError={patchBillingInfoError}
          />
        </div>

        <div className="field-row city-state-postcode">
          <CommonStanaloneInput
            key="billing-details-form-input-key-address-address-city"
            fieldName="address_city"
            label={t("City")}
            initValue={billingInfo.address_city}
            executedAction={patchBillingInfo}
            patchError={patchBillingInfoError}
          />
          <CommonStanaloneInput
            key="billing-details-form-input-key-address-address-state"
            fieldName="address_state"
            label={t("State (optional)")}
            initValue={billingInfo.address_state}
            executedAction={patchBillingInfo}
            patchError={patchBillingInfoError}
          />
          <CommonStanaloneInput
            key="billing-details-form-input-key-address-address-postcode"
            fieldName="address_postcode"
            label={t("Postcode")}
            initValue={billingInfo.address_postcode}
            executedAction={patchBillingInfo}
            patchError={patchBillingInfoError}
          />
        </div>
      </div>
    </div>
  );


  return (
    <div className="billing-details-form__component">
      {loader}
      {billingDetailsError}
      {billingDetails}
    </div>
  );
};

BillingDetailsForm.propTypes = {
  fetchBillingInfo: PropTypes.func.isRequired,
  clearFetchBillingInfo: PropTypes.func.isRequired,
  patchBillingInfo: PropTypes.func.isRequired,
  clearPatchBillingInfo: PropTypes.func.isRequired,
  billingInfo: PropTypes.object,
  billingInfoError: PropTypes.object,
  patchBillingInfoSuccess: PropTypes.object,
  patchBillingInfoError: PropTypes.object,
};

BillingDetailsForm.defaultProps = {
  billingInfo: null,
  billingInfoError: null,
  patchBillingInfoSuccess: null,
  patchBillingInfoError: null,
};

const mapStateToProps = state => (
  {
    billingInfo: state.billingReducer.billingInfo,
    billingInfoError: state.billingReducer.billingInfoError,
    patchBillingInfoSuccess: state.billingReducer.patchBillingInfoSuccess,
    patchBillingInfoError: state.billingReducer.patchBillingInfoError,
  }
);

export default connect(
  mapStateToProps,
  {
    fetchBillingInfo,
    clearFetchBillingInfo,
    patchBillingInfo,
    clearPatchBillingInfo,
  },
)(BillingDetailsForm);
